import { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/wa-abs.png";
import Architecture from "./../../assets/images/banner/Architecture.png";
// import Brochures from "./../../assets/images/WA_AB_girl1.pdf";
import { Link } from "react-router-dom";

const resultsData = [
  {
    metric: "Customer waiting time",
    before: "Customers call or wait for manual replies",
    after: "Customers book instantly through WhatsApp",
  },
  {
    metric: "Appointment handling",
    before: "Staff manually checks slots and confirms bookings",
    after: "Service, date, and time slot selection is automated",
  },
  {
    metric: "No-shows",
    before: "Customers may forget appointments",
    after: "Automated reminders help reduce no-shows",
  },
  {
    metric: "Booking accuracy",
    before: "Manual mistakes in service, date, or time",
    after: "Structured booking details are captured clearly",
  },
  {
    metric: "Rescheduling effort",
    before: "Staff must handle changes manually",
    after: "Customers can reschedule or cancel more easily",
  },
  {
    metric: "Customer experience",
    before: "Slow booking process and long queues",
    after: "Faster, smoother, WhatsApp-based booking experience",
  },
];

const featureCards = [
  {
    icon: "bi bi-whatsapp",
    title: "WhatsApp-Based Appointment Booking",
    desc: "Customers can book appointments directly on WhatsApp without downloading a separate app or visiting a website.",
  },
  {
    icon: "bi bi-calendar-check-fill",
    title: "Service, Date & Time Slot Selection",
    desc: "Customers can select the required service, preferred date, and available time slot in a simple guided flow.",
  },
  {
    icon: "bi bi-check2-circle",
    title: "Instant Booking Confirmation",
    desc: "The system confirms bookings instantly and captures customer details for scheduling and follow-up.",
  },
  {
    icon: "bi bi-bell-fill",
    title: "Automated Reminders",
    desc: "Appointment reminders and follow-up alerts can be sent automatically to reduce missed appointments.",
  },
  {
    icon: "bi bi-arrow-repeat",
    title: "Easy Reschedule or Cancellation",
    desc: "Customers can request appointment changes through WhatsApp, making the process easier for both staff and customers.",
  },
  {
    icon: "bi bi-speedometer2",
    title: "Real-Time Booking Dashboard",
    desc: "Appointment details can be stored and viewed in a dashboard for staff scheduling, tracking, and reporting.",
  },
];

const faqs = [
  {
    q: "How does WhatsApp appointment booking work?",
    a: "Customers open WhatsApp, select the required service, choose a preferred date and time slot, enter their details, and receive an instant booking confirmation.",
  },
  {
    q: "Do customers need to install a separate app?",
    a: "No. Customers can use WhatsApp directly, making it simple for salons, spas, clinics, service centers, and other appointment-based businesses.",
  },
  {
    q: "Can the system send reminders?",
    a: "Yes. Automated appointment reminders and follow-up alerts can be sent through WhatsApp to help reduce no-shows.",
  },
  {
    q: "Can customers reschedule or cancel appointments?",
    a: "Yes. The system can support reschedule and cancellation flows based on your business process.",
  },
  {
    q: "Can staff view bookings in a dashboard?",
    a: "Yes. Booking details can be stored and displayed in a dashboard so your team can track appointments, customer details, selected services, dates, and time slots.",
  },
  {
    q: "Which businesses can use this solution?",
    a: "This solution is suitable for salons, spas, clinics, dental practices, beauty centers, consultants, repair services, training centers, and other service-based businesses.",
  },
];

const Wa_ABS = () => {
  pageTitle("WhatsApp Appointment Booking System");

  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = "6581685898";
    const message =
      "Hello! I would like to know more about the WhatsApp Appointment Booking System.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message,
    )}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project">
              AI-Powered WhatsApp <br />
              Appointment Booking
            </h2>
          </div>

          <div className="siw-hero-price-box-sol">
            <h3>From SGD 100/month</h3>

            <button
              onClick={handleWhatsAppClick}
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              Start a Free Trial
            </button>
          </div>
        </div>
      </div>

      <section className="py-3 py-md-4">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  Built for simple WhatsApp appointment booking
                </h3>

                <p className="mb-0 siw-rpa-desc">
                  Customers no longer need to call, wait for replies, or fill
                  long forms to book an appointment. With our AI-powered
                  WhatsApp Appointment Booking System, customers can select the
                  service, preferred date, and available time slot directly
                  through WhatsApp.
                </p>

                <p className="siw-rpa-desc">
                  The system captures customer details, confirms the booking
                  instantly, and stores appointment records for scheduling,
                  reminders, dashboard tracking, and follow-up alerts. It is
                  designed for spas, salons, clinics, service centers, and other
                  appointment-based businesses that want to reduce manual work
                  and improve customer experience.
                </p>
              </div>
            </div>

            <div className="col-lg-5 d-flex">
              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/wmpuRPpPTP4?si=rdtO9M1k_lEev4RL"
                  title="WhatsApp Appointment Booking System Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3 pt-md-0 pb-md-5 wafod-features-section">
        <div className="container">
          <h3 className="wafod-section-heading">Architecture</h3>

          <img
            src={Architecture}
            alt="WhatsApp Appointment Booking Architecture"
            className="img-fluid mb-4"
            height="200"
          />

          <div className="mb-5">
            <h3 className="wafod-section-heading">Key Features</h3>
          </div>

          <div className="row g-4">
            {featureCards.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="food-feature-card wafod-feature-card h-100">
                  <div className="food-feature-icon wafod-feature-icon">
                    <i className={item.icon}></i>
                  </div>

                  <h5 className="wafod-card-title">{item.title}</h5>
                  <p className="mb-0 wafod-card-text">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-3 py-md-5 wafod-results-section">
        <div className="container">
          <div className="mb-4">
            <h3 className="wafod-section-heading-light pb-1">
              Business Impact
            </h3>
          </div>

          <div className="siw-subscription-table-wrap">
            <table className="siw-subscription-table">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>

              <tbody>
                {resultsData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.metric}</td>
                    <td>{row.before}</td>
                    <td>{row.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="pt-3 pb-2 py-md-4 wafod-faq-section">
        <div className="container">
          <div className="mb-5">
            <h3 className="wafod-section-heading">Common Questions</h3>
          </div>

          <div className="accordion wafod-accordion">
            {faqs.map((item, index) => (
              <div
                className="accordion-item food-accordion-item wafod-accordion-item mb-3"
                key={index}
              >
                <h2 className="accordion-header wafod-accordion-header">
                  <button
                    type="button"
                    className={`accordion-button food-accordion-btn wafod-accordion-btn ${
                      openIndex !== index ? "collapsed" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                  >
                    {item.q}
                  </button>
                </h2>

                <div
                  className={`accordion-collapse collapse ${
                    openIndex === index ? "show" : ""
                  }`}
                >
                  <div className="accordion-body wafod-accordion-body">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default Wa_ABS;
